const getParameters = () => {
  let uri = window.location.search.substring(1);
  let params = new URLSearchParams(uri);
  return params;
};

function b64DecodeUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  // https://stackoverflow.com/a/30106551
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );
}

const getData = () => {
  /* */
  const fallback = '';
  /* *
  let fallback = '';
  /* *
  // test;
  const test =
    'ewoJImNvbXBhbnlpZCI6ICI4Y2Q4ZWNmOC1hMjgzLTQxMGMtYWNhYy0wZWJmMjExMTJmYTMiLAoJInJvb2Z0b3BpZHMiOiAiREszMTA4MjAyMCxESzMxMDg0MDIwLERLMzEwODYwMjAiLAoJInJvb2Z0b3BpZCI6ICJESzMxMDgyMDIwIiwKCSJjdWx0dXJlIjogImRhLURLIiwKCSJjYWxlbmRhcmJ1ZmZlciI6IDMsCgkiY2FsZW5kYXJpbnRlcnZhbCI6IDMsCgkiZW5hYmxlcmVudGFsIjogdHJ1ZSwKCSJzZXJ2aWNlc3ByaWNlIjogdHJ1ZSwKCSJzZXJ2aWNlc3RpbWUiOiB0cnVlLAoJImNvbG9yZm9udCI6ICIjMjIyMjIyIiwKCSJjb2xvcnByaW1hcnkiOiAiI2I3MDIwMiIsCgkiY29sb3JzZWNvbmRhcnkiOiAiIzIyMjIyMiIsCgkiY29sb3JiYWNrZ3JvdW5kIjogIiNmZmZmZmYiLAoJInRlc3QiOiB0cnVlLAoJImd0bSI6IHsKCQkiZW5hYmxlZCI6IHRydWUsCgkJImlkIjogIiIKCX0KfQ==';
  fallback = test;
  /* *
  // cdk:
  const live =
    'ewoJIndpZGdldGlkIjogIjNDNDMyOEFGLUY5QTctNDE0My04QUNDLUI4OEM4REIxMTFFNyIsCgkiY29tcGFueWlkIjogIjJFODk3MEM2LTUxQTgtNEE1Ni1CMTE2LTE5QjM0RTgwQzU3OCIsCgkicm9vZnRvcGlkcyI6ICJESzM3NTc0NTIwIiwKCSJndG1pZCI6ICJHVE0tNTVWVkhTNSIsCgkiY3VsdHVyZSI6ICJkYS1ESyIsCgkiY29sb3JwcmltYXJ5IjogIiMxOTZjOWUiLAoJImNvbG9yc2Vjb25kYXJ5IjogIiMyMjIyMjIiLAoJImNvbG9yYmFja2dyb3VuZCI6ICIjZmZmZmZmIiwKCSJjb2xvcmZvbnQiOiAiIzIyMjIyMiIsCgkic2VydmljZXNwcmljZSI6ICJvbiIsCgkic2VydmljZXN0aW1lIjogIm9uIiwKCSJjYWxlbmRhcmJ1ZmZlciI6ICIzIiwKCSJjYWxlbmRhcmludGVydmFsIjogMywKCSJlbmFibGVyZW50YWwiOiAib24iLAoJInJlZmVycmVyIjogImh0dHA6Ly9sb2NhbGhvc3Q6ODA4MC9jcmVhdGUuaHRtbCIKfQ==';
  fallback = live;
  /* *
  // cdk w. manual times:
  const live =
    'ewoJIndpZGdldGlkIjogIjNDNDMyOEFGLUY5QTctNDE0My04QUNDLUI4OEM4REIxMTFFNyIsCgkiY29tcGFueWlkIjogIjJFODk3MEM2LTUxQTgtNEE1Ni1CMTE2LTE5QjM0RTgwQzU3OCIsCgkicm9vZnRvcGlkcyI6ICJESzM3NTc0NTIwIiwKCSJndG1pZCI6ICJHVE0tNTVWVkhTNSIsCgkiY3VsdHVyZSI6ICJkYS1ESyIsCgkiY29sb3JwcmltYXJ5IjogIiMxOTZjOWUiLAoJImNvbG9yc2Vjb25kYXJ5IjogIiMyMjIyMjIiLAoJImNvbG9yYmFja2dyb3VuZCI6ICIjZmZmZmZmIiwKCSJjb2xvcmZvbnQiOiAiIzIyMjIyMiIsCgkic2VydmljZXNwcmljZSI6ICJvbiIsCgkic2VydmljZXN0aW1lIjogIm9uIiwKCSJjYWxlbmRhcmJ1ZmZlciI6ICIzIiwKCSJjYWxlbmRhcmludGVydmFsIjogMywKCSJlbmFibGVyZW50YWwiOiAib24iLAoJInJlZmVycmVyIjogImh0dHA6Ly9sb2NhbGhvc3Q6ODA4MC9jcmVhdGUuaHRtbCIsCgkidGltZXMiOiAiWyc5OjAwJywnOTozMCcsICcxMDowMCcsJzEwOjMwJywgJzExOjAwJywnMTE6MzAnLCAnMTI6MDAnLCcxMjozMCddIiwKCSJ0aW1lc3dhaXRpbmciOiAiWyc5OjAwJywnOTozMCcsICcxMDowMCcsJzEwOjMwJywgJzExOjAwJywnMTE6MzAnLCAnMTI6MDAnLCcxMjozMCddIiwKCSJ0aW1lc3JlbnRhbCI6ICJbJzk6MDAnLCc5OjMwJywgJzEwOjAwJywnMTA6MzAnLCAnMTE6MDAnLCcxMTozMCcsICcxMjowMCcsJzEyOjMwJ10iLAogICAgICAgICJ0aW1lc3JlcGxhY2UiOiAidHJ1ZSIKfQ==';
  fallback = live;
  /* *
  // datamann:
  const datamann =
    'ewogICAid2lkZ2V0aWQiOiI5OThENjI0My03NjY4LTQ0RTgtOUYxRi1CNkVGQjM0RDc0ODAiLAogICAiY29tcGFueWlkIjoiOEIzRjU0QzEtNEYyMC00MTlCLUI3NzUtODg2QTQzQzY0QTg1IiwKICAgInJvb2Z0b3BpZHMiOiJEQTk5OTkyIiwKICAgInJvb2Z0b3BpZCI6IkRBOTk5OTIiLAogICAiY3VsdHVyZSI6ImRhLURLIiwKICAgImNhbGVuZGFyYnVmZmVyIjozLAogICAiY2FsZW5kYXJpbnRlcnZhbCI6MywKICAgImVuYWJsZXJlbnRhbCI6dHJ1ZSwKICAgInNlcnZpY2VzcHJpY2UiOnRydWUsCiAgICJzZXJ2aWNlc3RpbWUiOnRydWUsCiAgICJjb2xvcmZvbnQiOiIjMDAwMDAwIiwKICAgImNvbG9ycHJpbWFyeSI6IiMxYWJjOWMiLAogICAiY29sb3JzZWNvbmRhcnkiOiIjMjIyMjIyIiwKICAgImNvbG9yYmFja2dyb3VuZCI6IiNmZmZmZmYiLAogICAicmVmZXJyZXIiOiJodHRwOi8vbG9jYWxob3N0OjgwODAiCn0=';
  fallback = datamann;
  /* *
  // datamann w. overrides to times:
  const datamann2 =
    'ewogICAid2lkZ2V0aWQiOiI5OThENjI0My03NjY4LTQ0RTgtOUYxRi1CNkVGQjM0RDc0ODAiLAogICAiY29tcGFueWlkIjoiOEIzRjU0QzEtNEYyMC00MTlCLUI3NzUtODg2QTQzQzY0QTg1IiwKICAgInJvb2Z0b3BpZHMiOiJEQTk5OTkyIiwKICAgInJvb2Z0b3BpZCI6IkRBOTk5OTIiLAogICAiY3VsdHVyZSI6ImRhLURLIiwKICAgImNhbGVuZGFyYnVmZmVyIjozLAogICAiY2FsZW5kYXJpbnRlcnZhbCI6MywKICAgImVuYWJsZXJlbnRhbCI6dHJ1ZSwKICAgInNlcnZpY2VzcHJpY2UiOnRydWUsCiAgICJzZXJ2aWNlc3RpbWUiOnRydWUsCiAgICJjb2xvcmZvbnQiOiIjMDAwMDAwIiwKICAgImNvbG9ycHJpbWFyeSI6IiMxYWJjOWMiLAogICAiY29sb3JzZWNvbmRhcnkiOiIjMjIyMjIyIiwKICAgImNvbG9yYmFja2dyb3VuZCI6IiNmZmZmZmYiLAogICAidGltZXMiOiAiWyc5OjAwJywnOTozMCcsICcxMDowMCcsJzEwOjMwJywgJzExOjAwJywnMTE6MzAnLCAnMTI6MDAnLCcxMjozMCddIiwKICAgInRpbWVzLXdhaXRpbmciOiAiWyc5OjAwJywnOTozMCcsICcxMDowMCcsJzEwOjMwJywgJzExOjAwJywnMTE6MzAnLCAnMTI6MDAnLCcxMjozMCddIiwKICAgInRpbWVzLXJlbnRhbCI6ICJbJzk6MDAnLCc5OjMwJywgJzEwOjAwJywnMTA6MzAnLCAnMTE6MDAnLCcxMTozMCcsICcxMjowMCcsJzEyOjMwJ10iLAogICAicmVmZXJyZXIiOiJodHRwOi8vbG9jYWxob3N0OjgwODAiCn0=';
  fallback = datamann2;
  /* */
  const params = getParameters().get('contentdata');
  let parameters = params !== null ? JSON.parse(b64DecodeUnicode(params)) : fallback !== '' ? JSON.parse(b64DecodeUnicode(fallback)) : [];
  return parameters;
};

const getServices = () => {
  const fallback = '';
  //W3sKCSJqb2Jjb2RlIjogIkZPU09TTzExMCIsCgkicHJvZHVjdGNvZGUiOiAiIiwKCSJqb2JkZXNjcmlwdGlvbiI6ICJBbmRldCBhcmJlamRlIMO4bnNrZXMuIiwKCSJqb2J0aW1lIjogNjAsCgkiam9icHJpY2UiOiAwLAoJImpvYnR5cGVjb2RlIjogIiIsCgkiam9iZXh0ZGVzY3JpcHRpb24iOiAiIiwKCSJwYXJlbnRqb2Jjb2RlIjogIiIKfSwgewoJImpvYmNvZGUiOiAiU09MMSIsCgkicHJvZHVjdGNvZGUiOiAiIiwKCSJqb2JkZXNjcmlwdGlvbiI6ICJGw7hsZ2VuZGUgw7huc2tlczoiLAoJImpvYnRpbWUiOiA2MCwKCSJqb2JwcmljZSI6IDAsCgkiam9idHlwZWNvZGUiOiAiIiwKCSJqb2JleHRkZXNjcmlwdGlvbiI6ICIiLAoJInBhcmVudGpvYmNvZGUiOiAiIgp9XQ==
  const params = getParameters().get('services');
  let parameters = params !== null ? JSON.parse(b64DecodeUnicode(params)) : fallback !== '' ? JSON.parse(b64DecodeUnicode(fallback)) : [];
  return parameters;
};

const getKilometers = () => {
  const fallback = ''; //85000
  const params = getParameters().get('kilometers');
  let parameters = params !== null ? params : fallback;
  return parameters;
};

const getDebug = () => {
  return getParameters().get('debug');
};

const getAxios = () => {
  return getParameters().get('axios');
};

const getRegistrationPlate = () => {
  const fallback = '';
  /* *
  RK41033
  CH52381
  HØIBY
  TURBO
  /* */
  const params = getParameters().get('registrationplate');
  let parameters = params !== null ? params : fallback;
  return parameters;
};

const getContainerId = () => {
  const fallback = '';
  const params = getParameters().get('containerid');
  let parameters = params !== null ? params : fallback;
  return parameters;
};

const getHost = () => {
  const fallback = '';
  const params = getParameters().get('host');
  let parameters = params !== null ? params : fallback;
  return parameters;
};

const parameters = getData();
const services = getServices();
const registrationplate = getRegistrationPlate();
const kilometers = getKilometers();
const axios = getAxios();
const debug = getDebug();
const container = getContainerId();
const host = getHost();

export default {
  api: '/api',
  parameters,
  services,
  registrationplate,
  kilometers,
  axios,
  debug,
  container,
  host
};
